import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[replaceAccents]',
  standalone: false,
})
export class ReplaceAccentsDirective {
  private accentsMap: { [key: string]: string } = {
    Æ: 'AE',
    Þ: 'Th',
    ß: 'ss',
    æ: 'ae',
    þ: 'th',
    Đ: 'D',
    đ: 'd',
    '/': '',
  };
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement,
      initialValue = inputElement.value;
    inputElement.value = this.removeAccents(initialValue);

    if (initialValue !== inputElement.value) {
      event.stopPropagation();
    }
  }

  private removeAccents(str: string): string {
    return str
      .split('')
      .map((char) => {
        if (this.accentsMap.hasOwnProperty(char)) {
          return this.accentsMap[char];
        } else {
          return char.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
      })
      .join('');
  }
}
